import React from 'react';
import { useSelector } from 'react-redux';
import { formatGtmAttrs } from '@hpi-sox/hpstellar-utils';
import GlobalLink from '@hpi-sox/hpstellar-core/GlobalLink';
import { Typography, Reviews, List, ListItem } from '@hpi-sox/hpstellar-core/visId';
import { Helpers } from '../../../../../core';
import ProductImages from './product-images';
import ProductMobileBundleImages from './product-mobile-bundle-images';
import Offers from './offers';
import AllianceBadge from '../../../alliance-badge';

import './product-details.less';

const getTitleCase = Helpers.memoize(str => Helpers.titleCase(str));

export const ProductSpecs = ({ product }) => {
    const { specFirstGlance } = product || {};
    return (
        Array.isArray(specFirstGlance) &&
        specFirstGlance.length > 0 && (
            <List className="product-specs">
                {specFirstGlance.reduce((allSpecs, spec, idx) => {
                    if (typeof spec === 'string' && spec.length > 0) {
                        allSpecs.push(
                            <ListItem key={idx}>
                                <span dangerouslySetInnerHTML={Helpers.createMarkup(spec)} />
                            </ListItem>,
                        );
                    }
                    return allSpecs;
                }, [])}
            </List>
        )
    );
};

export const ProductTitle = ({ product, productLinkProps }) => {
    const {
        // btnProps: {
        //     children: ctaViewDetails,
        // },
        btnProps: productLinkBtnProps,
        to,
        gtmAction,
        preventDefault,
    } = productLinkProps || {};

    const { title } = product || {};

    return (
        <GlobalLink to={to} preventDefault={preventDefault} className="product-title" {...formatGtmAttrs(gtmAction)}>
            <Typography tag="h5" variant="h5">
                {title}
            </Typography>
        </GlobalLink>
    );
};

export default ({ product, ratings, productLinkProps, lazyLoad }) => {
    const { score = 0, reviewsCount, link } = ratings || {};
    const isMobile = useSelector(
        state => state && state.ui && state.ui.customBreakpoints && state.ui.customBreakpoints.visId === 'xsmall',
    );

    return (
        <div className="visid-product-tile-header">
            <ProductImages
                product={product}
                isMobile={isMobile}
                score={score}
                reviewsLink={link}
                productLinkProps={productLinkProps}
                lazyLoad={lazyLoad}
            />
            {!isMobile && (
                <Reviews
                    score={score}
                    reviewsCount={reviewsCount}
                    GlobalLinkProps={{ to: link }}
                    className="product-rating"
                />
            )}
            <ProductTitle product={product} productLinkProps={productLinkProps} />
            <AllianceBadge aiBadgeKey={product.facet_aipc} variant="visid-small" />
            <ProductSpecs product={product} />
            {isMobile && <ProductMobileBundleImages product={product} />}
            <Offers product={product} />
        </div>
    );
};
